import { render, staticRenderFns } from "./ElTextarea.vue?vue&type=template&id=45da35b2&scoped=true"
import script from "./ElTextarea.vue?vue&type=script&lang=js"
export * from "./ElTextarea.vue?vue&type=script&lang=js"
import style0 from "./ElTextarea.vue?vue&type=style&index=0&id=45da35b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da35b2",
  null
  
)

export default component.exports